/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.23",
    versionName: "0.2.0-nightly.2025.8.23",
    versionChannel: "nightly",
    buildDate: "2025-08-23T00:07:17.317Z",
    commitHash: "1d8c47a9103fa8ec7079d09d00081bd465a722b2",
};
